export const CALL_US_NUMBER = '844-395-1466';

export const CALL_US_TEL_HREF = 'tel:+18443951466';

export const CALL_US_MOBILE_LABEL = 'Need help? Call us';

export const CALL_US_DESKTOP_LABEL = `Need help? Call us at ${CALL_US_NUMBER}`;

export const CALL_US_MODAL_NUMBER = '844-395-1468';

export const CALL_US_MODAL_TEL_HREF = 'tel:+18443951468';
